/* Copyright (c) 2024 Xperi. All Rights Reserved. */

import { OnePassAndRecordingsUserSettings } from 'client-code/user-settings';

import type { TivoPayloadAction } from '../../../../core/tivo/tivo-redux-wrapper';
import {
    SET_GHOST_INDEX_ONEPASS_AND_RECORDING_OPTIONS,
    SET_ONEPASS_AND_RECORDING_ERROR,
    SET_ONEPASS_AND_RECORDING_OPTIONS,
    SET_SELECTED_INDEX_ONEPASS_AND_RECORDING_OPTIONS,
} from './onepassandrecordings.types';

interface OnePassRecordingOptionsState {
    selectedIndex: number;
    hasError: boolean;
    ghostMode: boolean;
    options?: OnePassAndRecordingsUserSettings;
}

const initialState: OnePassRecordingOptionsState = {
    selectedIndex: 0,
    hasError: false,
    ghostMode: false,
    options: undefined,
};

const onePassRecordingOptionsReducer = (
    state = initialState,
    { type, payload } = <TivoPayloadAction<OnePassRecordingOptionsState>>{},
) => {
    switch (type) {
        case SET_SELECTED_INDEX_ONEPASS_AND_RECORDING_OPTIONS:
            return {
                ...state,
                selectedIndex: payload.selectedIndex,
            };
        case SET_GHOST_INDEX_ONEPASS_AND_RECORDING_OPTIONS:
            return {
                ...state,
                ghostMode: payload.ghostMode,
            };
        case SET_ONEPASS_AND_RECORDING_OPTIONS:
            return {
                ...state,
                options: payload.options,
            };
        case SET_ONEPASS_AND_RECORDING_ERROR:
            return {
                ...state,
                hasError: payload.hasError,
            };
        default:
            return state;
    }
};

export const getVisibleOptionsCount = (options: OnePassAndRecordingsUserSettings) => {
    if (!options?.settingsOptions) {
        return 0;
    }
    return Object.values(options.settingsOptions).filter((value) => value.visibility).length;
};

export default onePassRecordingOptionsReducer;
